var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m125 66.1c0-4.2-0.4-8.3-1-12.4h-59.9v23.2h34.1c-1.5 7.5-6.1 13.8-12.9 18.1v15.1h19.5c11.4-10.5 18-25.9 18-44z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.1 128c17.5 0 32.3-5.8 43-15.6l-19.5-15.1c-5.8 3.9-13.2 6.2-23.5 6.2-18.1 0-33.4-12.2-38.9-28.5h-20.2v15.6c11.6 23 34.9 38.9 62.1 38.9z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2 77.6c-1.2-3.6-1.9-7.5-1.9-11.5s0.7-7.9 1.9-11.5v-15.6h-20.2c-4.1 8.2-6.6 17.6-6.6 27.1s2.4 18.9 6.6 27.1l20.2-15.6z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.1 24.5c9.5 0 18.1 3.3 24.9 9.8l17.3-17.3c-10.3-9.6-23.8-15.6-39.2-15.6-27.2 0-50.5 15.9-62.1 38.9l20.2 15.6c5.5-16.3 20.8-28.5 38.9-28.5z",
    fill: "#ea4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ee698d2749e579ae496738594f1dd2be.svg";
export { ForwardRef as ReactComponent };